import leftTabMenu from './leftTabMenu.vue'
leftTabMenu.install = Vue => Vue.component(leftTabMenu.name, leftTabMenu);
export default leftTabMenu;


// WEBPACK FOOTER //
// ./src/myPlugin/index.js